export default __webpack_public_path__ + "static/media/botvinnik.a4ce029a.txt";